import React, { createRef, useState } from 'react';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TooltipTrigger from 'components/TooltipTrigger';
import LayerTrigger from 'components/LayerTrigger';
import './AttachMore.scss';

export interface Props {
  maxAttachments: number;
  disabled: boolean;
  onClick?: () => void;
  // allows an external component (e.g. <Integrations />) to provide services to the LayerTrigger in this component)
  controlledMenuLayer?: (layerTrigger: LayerTrigger | null) => React.ReactElement;
}

const AttachMore = ({ maxAttachments, controlledMenuLayer, disabled, onClick }: Props) => {
  const cardLayerTriggerRef = createRef<LayerTrigger>();
  const tooltipLayerTriggerRef = createRef<LayerTrigger>();
  const [hovercardOpen, setHovercardOpen] = useState(false);

  const containerClass = `attachMoreContainer${disabled ? ' attachMoreContainer-disabled' : ''}`;

  const textWithTooltip = (
    <TooltipTrigger
      tooltip={`Add up to ${maxAttachments} attachments`}
      alignment="left"
      placement="top"
    >
      <div className={containerClass} data-testid="attach-more" onClick={onClick}>
        <div className="iconContainer">
          <Icon name="x" size="large" />
        </div>
        <Text className="attachMore">
          Attach
          <br />
          more
        </Text>
      </div>
    </TooltipTrigger>
  );

  if (disabled || !controlledMenuLayer) {
    return textWithTooltip;
  }

  return (
    <LayerTrigger
      trigger={['click', 'manual']}
      ref={cardLayerTriggerRef}
      alignment="left"
      placement="top"
      layer={controlledMenuLayer ? controlledMenuLayer(cardLayerTriggerRef.current) : <></>}
      onShow={() => setHovercardOpen(disabled)}
      onHide={() => setHovercardOpen(false)}
      dynamicMode={true}
    >
      <Text
        className="attachMore"
        onMouseEnter={() => {
          if (!hovercardOpen) {
            tooltipLayerTriggerRef.current?.handleDelayedShow();
          }
        }}
        onMouseLeave={() => tooltipLayerTriggerRef.current?.handleDelayedHide()}
      >
        {textWithTooltip}
      </Text>
    </LayerTrigger>
  );
};

export default AttachMore;
